/* Allied Motor Parts — product page behaviours rebuilt from ConvertCart campaigns */
(function () {
  'use strict';
  if (!document.body.classList.contains('template-product')) return;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---- Warranty badge: move it next to the review stars when they exist (45299838) ---- */
  var warranty = $('.cc-warranty-section');
  if (warranty) {
    var badgeHost = $('.jdgm-widget.jdgm-preview-badge') || $('.jdgm-prev-badge');
    if (badgeHost && badgeHost.parentNode) {
      badgeHost.parentNode.style.display = 'flex';
      badgeHost.parentNode.style.alignItems = 'center';
      badgeHost.parentNode.style.flexWrap = 'wrap';
      badgeHost.parentNode.appendChild(warranty);
    }
    var tag = $('.cc-warranty-tag', warranty);
    var close = $('.cc-wp-close', warranty);
    tag.addEventListener('click', function (e) { e.preventDefault(); warranty.classList.toggle('cc-wp-show'); });
    if (close) close.addEventListener('click', function () { warranty.classList.remove('cc-wp-show'); });
    document.addEventListener('click', function (e) { if (!warranty.contains(e.target)) warranty.classList.remove('cc-wp-show'); });
  }

  /* ---- "I'm unsure if it will fit" overlay (10282732 / 20179170) ---- */
  var fitLink = $('.cc-compatibility-button-section a');
  var overlay = $('.cc-compatibility-overlay');
  if (fitLink && overlay) {
    var tableBlock = $('.cc-compatibility-table-block', overlay);
    function fillTable() {
      if (tableBlock.getAttribute('data-filled')) return;
      var src = $('#testAppend');
      if (src && src.rows.length > 1) {
        tableBlock.innerHTML = '';
        tableBlock.appendChild(src.cloneNode(true)).removeAttribute('id');
      } else {
        tableBlock.innerHTML = '<p class="cc-compatibility-empty">Fitment for this casting is confirmed by phone. Have your casting number and vehicle year, make and engine ready.</p>';
      }
      tableBlock.setAttribute('data-filled', '1');
    }
    fitLink.addEventListener('click', function (e) { e.preventDefault(); fillTable(); overlay.classList.add('cc-open'); document.body.style.overflow = 'hidden'; });
    function closeOverlay() { overlay.classList.remove('cc-open'); document.body.style.overflow = ''; }
    $('.cc-compatibility-close', overlay).addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeOverlay(); });
  }

  /* ---- Always-visible add-to-cart bar: submits the main form, mirrors price/availability ---- */
  var bar = $('.cc-cartbar');
  var mainForm = $('form[action*="/cart/add"].shopify-product-form') || $('form[action*="/cart/add"]');
  var mainBtn = mainForm ? $('button[name="add"]', mainForm) : null;
  if (bar && mainForm && mainBtn) {
    var barBtn = $('.cc-action-atc', bar);
    var variantIn = $('input[name="id"]', mainForm);
    var scope = mainForm.closest('.product-single') || document;
    function syncState() {
      var disabled = mainBtn.disabled;
      barBtn.disabled = disabled;
      barBtn.textContent = disabled ? 'Sold out' : 'Add to Cart';
      var price = $('.product-price--single .product-price__price', scope);
      var sale = $('.product-price--single .product-price__sale', scope);
      if (price) $('.cc-new-price', bar).textContent = price.textContent.trim();
      $('.cc-old-price', bar).textContent = sale ? sale.textContent.trim() : '';
    }
    syncState();
    if (variantIn) new MutationObserver(syncState).observe(variantIn, { attributes: true, attributeFilter: ['value'] });
    new MutationObserver(syncState).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });
    barBtn.addEventListener('click', function () { mainBtn.click(); });
  }

  /* ---- Keep the Tidio chat bubble above the bar (Tidio renders in a shadow root) ---- */
  function tidioLiftPx() {
    if (!bar) return 0;
    var top = bar.getBoundingClientRect().top;
    return Math.max(0, Math.round(window.innerHeight - top) + 8);
  }
  function liftTidio() {
    var host = document.getElementById('tidio-chat');
    if (!host || !host.shadowRoot) return false;
    var st = host.shadowRoot.querySelector('#cc-tidio-lift');
    if (!st) { st = document.createElement('style'); st.id = 'cc-tidio-lift'; host.shadowRoot.appendChild(st); }
    st.textContent = '#tidio-chat-root:has(#button.chat-closed){margin-bottom:' + tidioLiftPx() + 'px!important}';
    return true;
  }
  if (!liftTidio()) {
    document.addEventListener('tidioChat-ready', liftTidio);
    var tidioTries = 0, tidioTimer = setInterval(function () { if (liftTidio() || ++tidioTries > 40) clearInterval(tidioTimer); }, 500);
  }
  window.addEventListener('resize', liftTidio);

  /* ---- Shopify preview/draft bar (only on unpublished-theme previews): sit above it so the button stays reachable ---- */
  if (bar) {
    var pbTries = 0, pbTimer = setInterval(function () {
      var pb = document.getElementById('PBarNextFrame');
      if (pb && pb.parentElement) { bar.style.bottom = pb.parentElement.offsetHeight + 'px'; liftTidio(); clearInterval(pbTimer); }
      else if (++pbTries > 20) clearInterval(pbTimer);
    }, 500);
  }

  /* ---- Mobile: put "Shipping calculated at checkout" and the quantity box on one row ---- */
  if (window.matchMedia('(max-width: 767px)').matches && mainForm) {
    var policies = $('.product__policies', mainForm);
    var qtyRow = $('.product-form__item--quantity', mainForm);
    if (policies && qtyRow) qtyRow.insertBefore(policies, qtyRow.firstChild);
  }

  /* ---- Read more / read less on the description (24968875), mobile only ---- */
  var desc = $('.pg__tabs .tab-pane .rte');
  if (desc && window.matchMedia('(max-width: 767px)').matches && desc.scrollHeight > 320) {
    var wrap = document.createElement('div');
    wrap.className = 'cc-readmore-wrap cc-collapsed';
    desc.parentNode.insertBefore(wrap, desc);
    wrap.appendChild(desc);
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'cc-read-toggle'; btn.textContent = 'Read more';
    wrap.appendChild(btn);
    btn.addEventListener('click', function () {
      var c = wrap.classList.toggle('cc-collapsed');
      btn.textContent = c ? 'Read more' : 'Read less';
    });
  }
})();
